// ============================================================
// HABIT OS — Protokolle (erweitert)
// Basierend auf dokumentierten, öffentlich belegten Routinen.
// Quellen: Interviews, Bücher, Podcasts, offizielle Aussagen.
// ============================================================

export const ROUTINES = {

  // ── EIGENE ROUTINE ────────────────────────
  custom: {
    id: "custom",
    name: "✏️ Meine eigene Routine",
    description: "Starte mit einer leeren Routine und füge nur die Habits hinzu die zu dir passen. Kein Protokoll, keine Vorgaben — nur du.",
    category: "custom",
    icon: "✏️",
    morning: [],
    night: [],
  },

  // ── BESTEHENDE PROTOKOLLE ─────────────────
  basic: {
    id: "basic",
    name: "🌱 Beginner Blueprint",
    description: "Der perfekte Einstieg in ein strukturiertes Leben.",
    category: "starter",
    morning: [
      { id: "m_b1", label: "💧 Wasser & Creatin", isHero: true },
    ],
    night: [
      { id: "n_b1", label: "🌅 Digital Sunset (Screens off)", isHero: false },
    ],
  },

  neuro: {
    id: "neuro",
    name: "🧠 The Neuro-Optimizer",
    description: "Einstieg in die Neurobiologie-basierte Optimierung. Die wichtigsten Grundlagen für Fokus, Energie und Schlaf.",
    category: "performance",
    morning: [
      { id: "m_n1", label: "☀️ 10–30 Min. Tageslicht nach dem Aufwachen (nicht direkt in die Sonne schauen)", isHero: false },
      { id: "m_n2", label: "💧 Wasser, Elektrolyte & Creatin", isHero: true },
      { id: "m_n3", label: "☕ 90 Min. warten bis zum ersten Kaffee", isHero: false },
    ],
    night: [
      { id: "n_n1", label: "🌡️ Raumtemperatur auf 18 °C senken", isHero: false },
      { id: "n_n2", label: "💊 Magnesium L-Threonat laut Herstellerangabe", isHero: false },
    ],
  },

  athlete_protocol: {
    id: "athlete_protocol",
    name: "💪 The Athlete Protocol",
    description: "Für maximale Regeneration, Kraft und mentale Schärfe.",
    category: "performance",
    morning: [
      { id: "m_a1", label: "🏃 5–10 Min. leichtes Aufwärmen / Mobility", isHero: false },
      { id: "m_a2", label: "💧 500 ml Wasser + Creatin + Elektrolyte", isHero: true },
      { id: "m_a3", label: "🥚 Proteinreiches Frühstück", isHero: false },
    ],
    night: [
      { id: "n_a1", label: "🧊 Kalte Dusche oder Kontrastwasser — bei Herz-Kreislauf-Erkrankungen vorher ärztlich abklären", isHero: false },
      { id: "n_a2", label: "📊 Trainingslog ausfüllen", isHero: false },
      { id: "n_a3", label: "😴 Schlafzeit fixieren (22–23 Uhr)", isHero: false },
    ],
  },

  // ── VORBILDER-PROTOKOLLE ──────────────────

  athlete: {
    id: "athlete",
    name: "⚡ The Athlete",
    description: "Polyphasischer Schlaf, 6 Mahlzeiten täglich, obsessive Erholung. Das System des ausdauerndsten Athleten der Geschichte.",
    category: "rolemodel",
    icon: "⚡",
    focus: "Athletische Ausdauer & Erholung",
    morning: [
      { id: "m_cr1", label: "🏊 Kaltdusche direkt nach dem Aufwachen", isHero: true },
      { id: "m_cr2", label: "🤸 Stretching & leichtes Mobility-Warm-Up (15 Min.)", isHero: false },
      { id: "m_cr3", label: "💧 Sofort hydratisieren — Wasser + Elektrolyte", isHero: false },
      { id: "m_cr4", label: "🐟 Proteinreiches Frühstück: Eier, Fisch, Vollkorn", isHero: false },
    ],
    night: [
      { id: "n_cr1", label: "🏊 30–60 Min. entspanntes Schwimmen zur Regeneration", isHero: false },
      { id: "n_cr2", label: "💆 Massage oder Theragun zur Muskelentspannung", isHero: false },
      { id: "n_cr3", label: "📱 Alle Screens 30 Min. vor dem Schlafen aus", isHero: true },
      { id: "n_cr4", label: "🛏️ Schlafzimmer kühlen — feste Schlafenszeit ab 23 Uhr", isHero: false },
    ],
  },

  warrior: {
    id: "warrior",
    name: "🔥 The Warrior",
    description: "Ausdauer, Stretching und Eigenverantwortung. Umfang an den eigenen Trainingsstand anpassen.",
    category: "rolemodel",
    icon: "🔥",
    focus: "Mentale Härte & Ausdauer",
    morning: [
      { id: "m_gg1", label: "⏰ Aufstehen zwischen 3–5 Uhr ohne Snooze", isHero: true },
      { id: "m_gg2", label: "🏃 Morgenlauf in einer Distanz, die zu deinem Trainingsstand passt", isHero: false },
      { id: "m_gg3", label: "🪞 Accountability Mirror: Ziele laut vorlesen", isHero: false },
      { id: "m_gg4", label: "☕ Bulletproof Coffee (Kaffee + MCT-Öl + Butter) + 2 Eier", isHero: false },
    ],
    night: [
      { id: "n_gg1", label: "🧘 2 Stunden Stretching + Meditation (täglich, nie auslassen)", isHero: true },
      { id: "n_gg2", label: "📓 Tages-Review: Was habe ich heute vermieden? Was bleibt offen?", isHero: false },
      { id: "n_gg3", label: "🛏️ Schlafen um 21–22 Uhr für 6–7 Stunden", isHero: false },
    ],
  },

  legend: {
    id: "legend",
    name: "🏆 The Legend",
    description: "9 Stunden Schlaf, 80% pflanzlich, extreme Hydration, Pliability-Training.",
    category: "rolemodel",
    icon: "🏆",
    focus: "Langfristig fit bleiben",
    morning: [
      { id: "m_tb1", label: "💧 20 oz Wasser mit Elektrolyten direkt nach dem Aufwachen", isHero: true },
      { id: "m_tb2", label: "🤸 Pre-Workout Pliability-Session (20 Min. Deep-Tissue Mobilisierung)", isHero: false },
      { id: "m_tb3", label: "🥤 Protein-Smoothie: Blaubeeren, Banane, Nüsse, Samen", isHero: false },
      { id: "m_tb4", label: "💪 Functional Strength & Conditioning (2 Std.)", isHero: false },
    ],
    night: [
      { id: "n_tb1", label: "🌿 Pliability Roller: alle Muskelgruppen durchrollen (20 Min.)", isHero: false },
      { id: "n_tb2", label: "🥗 Frühes Abendessen — mindestens 3 Std. vor dem Schlafen", isHero: false },
      { id: "n_tb3", label: "📱 Alle elektronischen Geräte 30 Min. vor dem Schlafen aus", isHero: false },
      { id: "n_tb4", label: "🛏️ Schlafen um 20:30–21:00 Uhr — Schlafzimmer auf 15–18°C", isHero: true },
    ],
  },

  operator: {
    id: "operator",
    name: "💰 The Operator",
    description: "Simpel & brutal effektiv. Kein aufgeblähtes Morning-Ritual — erst arbeiten, dann Sport. Das System für maximale unternehmerische Hebelwirkung.",
    category: "rolemodel",
    icon: "💰",
    focus: "Unternehmer-Produktivität",
    morning: [
      { id: "m_ah1", label: "⏰ Aufstehen um 4–5 Uhr ohne Ritual", isHero: true },
      { id: "m_ah2", label: "☕ Kaffee — sofort an die Arbeit", isHero: false },
      { id: "m_ah3", label: "🎯 1–2 Stunden Deep Work: die wichtigste Aufgabe des Tages zuerst", isHero: false },
      { id: "m_ah4", label: "💪 Training nach der Arbeitsphase (Krafttraining, High Protein)", isHero: false },
    ],
    night: [
      { id: "n_ah1", label: "📋 Morgen planen: Top 3 Aufgaben nach Hebelwirkung priorisieren", isHero: true },
      { id: "n_ah2", label: "🍽️ Konstantes Abendessen — täglich das Gleiche (minimiert Entscheidungen)", isHero: false },
      { id: "n_ah3", label: "🛏️ Früh schlafen — Schlafenszeit wichtiger als Aufwachzeit", isHero: false },
    ],
  },

  grinder: {
    id: "grinder",
    name: "💎 The Grinder",
    description: "Prinzip einer 75-Tage-Challenge. Radikale Konsequenz, zwei Workouts täglich, null Kompromisse. Das System der extremen Selbstdisziplin.",
    category: "rolemodel",
    icon: "💎",
    focus: "Extreme Disziplin & Selbstentwicklung",
    morning: [
      { id: "m_af1", label: "🏋️ Erstes Training: 45 Min.+ Krafttraining oder Cardio (kein Skip)", isHero: true },
      { id: "m_af2", label: "📚 10 Seiten Non-Fiction lesen (Business, Mindset, Biographien)", isHero: false },
      { id: "m_af3", label: "💧 Über den Tag ausreichend trinken — morgens beginnen", isHero: false },
      { id: "m_af4", label: "🥗 Saubere Ernährung nach Plan — null Alkohol, null Cheat Meals", isHero: false },
    ],
    night: [
      { id: "n_af1", label: "🏃 Zweites Training abends — bei extremem Wetter drinnen", isHero: true },
      { id: "n_af2", label: "📸 Progress Photo täglich — visuelle Accountability", isHero: false },
      { id: "n_af3", label: "📓 Power List: 5 wichtige Aufgaben für morgen schreiben", isHero: false },
    ],
  },

  activator: {
    id: "activator",
    name: "⭐ The Activator",
    description: "5-Sekunden-Regel, High-Five-Gewohnheit, Herz-Kohärenz-Atmung. Wissenschaftlich fundierte Gewohnheiten für emotionale Resilienz.",
    category: "rolemodel",
    icon: "⭐",
    focus: "Mindset & Emotionale Resilienz",
    morning: [
      { id: "m_mr1", label: "✋ High-Five im Spiegel direkt nach dem Aufwachen", isHero: true },
      { id: "m_mr2", label: "🫀 Herz-Kohärenz-Atmung: 5 Sek. ein, 5 Sek. aus (5 Min.)", isHero: false },
      { id: "m_mr3", label: "☀️ Sofort aufstehen — 5-4-3-2-1 Countdown, kein Zögern", isHero: false },
      { id: "m_mr4", label: "📓 Morgen-Journaling: Gratitude + Intention für den Tag", isHero: false },
    ],
    night: [
      { id: "n_mr1", label: "🌿 Loslassen-Ritual: was nicht kontrollierbar ist, bewusst loslassen", isHero: false },
      { id: "n_mr2", label: "✋ Abend-High-Five: einen Moment des Tages feiern, egal wie klein", isHero: true },
      { id: "n_mr3", label: "💤 Schlaf-Vorbereitung: Fokus auf positive Momente des Tages", isHero: false },
    ],
  },

  sculptor: {
    id: "sculptor",
    name: "🏋️ The Sculptor",
    description: "5x Classic Physique Champion. Atemarbeit statt Koffein, morgendliche Cardio-Basis, 5–6 Mahlzeiten. Das System des symmetrischsten Körpers der Welt.",
    category: "rolemodel",
    icon: "🏋️",
    focus: "Physique & Bodybuilding",
    morning: [
      { id: "m_cb1", label: "🌬️ Atemübung im Sitzen oder Liegen (nie im Wasser oder beim Autofahren)", isHero: true },
      { id: "m_cb2", label: "🚶 Morgendliches Cardio: 25 Min. Treadmill + 25 Min. Stairmaster", isHero: false },
      { id: "m_cb3", label: "🥤 Protein-Shake mit Haferflocken + Eiweiß als Frühstück", isHero: false },
      { id: "m_cb4", label: "🏋️ Haupttraining: 5-Day Split mit progressiver Überlastung", isHero: false },
    ],
    night: [
      { id: "n_cb1", label: "🍽️ Letzte Mahlzeit: Casein-Protein + gesunde Fette vor dem Schlafen", isHero: false },
      { id: "n_cb2", label: "📊 Makros für den Tag tracken und morgen planen", isHero: true },
      { id: "n_cb3", label: "🧘 Stretching & Recovery: Muskeln nach intensivem Training mobilisieren", isHero: false },
    ],
  },

  monk: {
    id: "monk",
    name: "☯️ The Monk",
    description: "1500 Jahre Shaolin-Weisheit. Aufstehen bei Dunkel, Qi Gong, Kampfkunst als Meditation. Einheit von Körper, Geist und Seele.",
    category: "rolemodel",
    icon: "☯️",
    quote: "Disziplin ist nicht Zwang. Sie befreit den Geist von den Launen flüchtiger Wünsche.",
    focus: "Geist-Körper-Einheit & Innere Stärke",
    morning: [
      { id: "m_sy1", label: "🌅 Aufstehen um 5–6 Uhr — der Tag beginnt in der Stille vor der Welt", isHero: true },
      { id: "m_sy2", label: "🧘 Qi Gong oder Meditation (20–30 Min.) — Energie zentrieren vor jeder Aktivität", isHero: false },
      { id: "m_sy3", label: "🥋 Körpertraining: Kraft + Flexibilität + Koordination (90 Min.)", isHero: false },
      { id: "m_sy4", label: "🍚 Achtsames Frühstück in Stille: einfache Vollkornmahlzeit", isHero: false },
    ],
    night: [
      { id: "n_sy1", label: "🧘 Abend-Meditation: Gedanken beobachten ohne Bewertung (20 Min.)", isHero: true },
      { id: "n_sy2", label: "🌿 Leichtes, saisonales Abendessen — keine schwere Verdauungsarbeit vor dem Schlafen", isHero: false },
      { id: "n_sy3", label: "📵 Digitale Stille ab Sonnenuntergang — Bewusstsein nach innen richten", isHero: false },
      { id: "n_sy4", label: "🛏️ Schlafen um 21–22 Uhr — der Körper erholt sich im Einklang mit der Natur", isHero: false },
    ],
  },

  explorer: {
    id: "explorer",
    name: "🎙️ The Explorer",
    description: "Cold Plunge, Sauna, Mixed Martial Arts, Isolation Tank. Der vielseitigste Performance-Stack — neugierig auf alles, dogmatisch auf nichts.",
    category: "rolemodel",
    icon: "🎙️",
    focus: "Biohacking & Vielseitigkeit",
    morning: [
      { id: "m_jr1", label: "🧊 Kurze kalte Dusche nach dem Aufwachen — bei Herz-Kreislauf-Erkrankungen vorher ärztlich abklären", isHero: true },
      { id: "m_jr2", label: "🏋️ Training: Kampfsport, Krafttraining oder Cardio (60–90 Min.)", isHero: false },
      { id: "m_jr3", label: "🧖 Sauna nach dem Training (20–30 Min.)", isHero: false },
      { id: "m_jr4", label: "🥩 Ausgewogene erste Mahlzeit: Eiweiß, Gemüse, gesunde Fette", isHero: false },
    ],
    night: [
      { id: "n_jr1", label: "🎙️ Kreative Arbeit oder tiefes Lesen am Abend", isHero: false },
      { id: "n_jr2", label: "🌿 Entspannung: Familie, Lesen, Isolation Tank (wenn verfügbar)", isHero: false },
      { id: "n_jr3", label: "💊 Abendroutine: Magnesium laut Herstellerangabe", isHero: true },
    ],
  },

  // ── THE SCIENTIST (Huberman-inspiriert) ──
  scientist: {
    id: "scientist",
    name: "🔬 The Scientist",
    description: "Neurobiologie-basierte Optimierung. Morgenlicht, Adenosin-Clearing, NSDR, Kälte-Dopamin und präzises Schlaf-Protokoll.",
    category: "rolemodel",
    icon: "🔬",
    focus: "Neurobiologie & Kognitive Performance",
    morning: [
      { id: "m_sc1", label: "☀️ Nach dem Aufwachen 10–30 Min. ins Tageslicht (nicht direkt in die Sonne schauen)", isHero: true },
      { id: "m_sc2", label: "💧 Sofort: 500ml Wasser + Elektrolyte (Natrium, Kalium, Magnesium) — Zellen rehydrieren nach 8 Std. ohne Flüssigkeit", isHero: false },
      { id: "m_sc3", label: "⏱️ 90–120 Min. warten bis zum ersten Kaffee — Adenosin vollständig abbauen lassen bevor Koffein Rezeptoren blockiert", isHero: true },
      { id: "m_sc4", label: "🏋️ Training-Timing: 30 Min., 3 Std. oder 11 Std. nach dem Aufwachen (Cortisol-Peaks nutzen) — Kraft + Hypertrophie bevorzugt morgens", isHero: false },
      { id: "m_sc5", label: "🧊 Kurze kalte Dusche nach dem Training — bei Herz-Kreislauf-Erkrankungen vorher ärztlich abklären", isHero: false },
      { id: "m_sc6", label: "🥚 Erstes Essen: proteinreich, wenig Kohlenhydrate — Tyrosin für Dopamin-Synthese (Eier, Fleisch, Nüsse)", isHero: false },
    ],
    night: [
      { id: "n_sc1", label: "🧘 NSDR / Yoga Nidra: 10–20 Min. Non-Sleep Deep Rest am Nachmittag — zum Abschalten und Erholen", isHero: true },
      { id: "n_sc2", label: "🌅 Sonnenuntergang beobachten: 5–10 Min. Abendlicht — kalibriert zirkadianen Rhythmus für den Übergang in den Schlafmodus", isHero: false },
      { id: "n_sc3", label: "💡 Alle Lichter dimmen ab 22 Uhr — kein Deckenlicht, nur warme Lampen unter Augenhöhe (blaues Licht supprimiert Melatonin um 50%)", isHero: false },
      { id: "n_sc4", label: "🌡️ Schlafzimmer auf 18–19°C kühlen — Körperkerntemperatur muss 1–3°C sinken um einzuschlafen", isHero: false },
      { id: "n_sc5", label: "💊 Abend-Supplemente nur laut Herstellerangabe, bei Medikamenten vorher ärztlich abklären", isHero: true },
      { id: "n_sc6", label: "📵 Handy aus dem Schlafzimmer — kein Screen 30 Min. vor dem Schlafen. Letzte mentale Aktivität: Dankbarkeit oder leichtes Lesen", isHero: false },
    ],
  },
  bioathlete: {
    id:          "bioathlete",
    name:        "🌿 Bio-Athletik Protokoll",
    description: "Vollwertkost, Mahlzeiten rund ums Training und einfache Küchenrituale für Sportler.",
    category:    "performance",
    icon:        "🌿",
    quote:       "Der Körper vergisst nicht was du ihm gibst. Und er vergisst nicht was du ihm vorenthältst.",
    focus:       "Body Recomposition & Bio-Hacking",
    morning: [
      { id: "m_ba1", label: "🫒 Morgen-Shot: 1 EL Olivenöl + Saft ½ Zitrone", isHero: true },
      { id: "m_ba2", label: "🌾 Flohsamenschalen: 1 EL in 300ml Wasser, sofort trinken + 300ml nachspülen (06:10 Uhr)", isHero: false },
      { id: "m_ba3", label: "☀️ Vitamin D3 + K2 laut Herstellerangabe (bei Gerinnungshemmern vorher ärztlich abklären)", isHero: false },
      { id: "m_ba4", label: "🌴 Pre-Workout: 2 Datteln mit Bio-Ghee + Prise Meersalz (30 Min. vor Training)", isHero: false },
      { id: "m_ba5", label: "⚡ Post-Workout-Shake: Whey + Kreatin + Banane", isHero: true },
    ],
    night: [
      { id: "n_ba1", label: "🍲 Golden Broth: 300ml Knochenbrühe + Ingwer + Kurkuma + Pfeffer (Pre-Fußball oder Abend)", isHero: false },
      { id: "n_ba2", label: "🌙 Magnesium laut Herstellerangabe (22:30 Uhr)", isHero: true },
      { id: "n_ba3", label: "🧀 150g Hüttenkäse vor dem Schlafen (Casein-Protein)", isHero: false },
    ],
  },

};

// ─────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────

// Alle Routinen als Array
export const ROUTINE_LIST = Object.values(ROUTINES);

// Nach Kategorie filtern
export const ROUTINE_CATEGORIES = {
  starter:     { label: "Einstieg",         icon: "🌱" },
  performance: { label: "Performance",      icon: "⚡" },
  rolemodel:   { label: "Vorbilder",        icon: "🌟" },
};

export function getRoutinesByCategory(category) {
  return ROUTINE_LIST.filter((r) => r.category === category);
}